import React from 'react';
import './Title.css';
import Image from "./../../trashapp_logo.png";

const Title = () => {
  return (
    <div className="title-container">
      <div className="title">
        <h1>Verarbeitungsanlage</h1>
      </div>
      <div className="logo">
        <img src={Image}></img>
      </div>
    </div>
  )
}

export default Title;